import axios, { AxiosInstance } from "axios";
import { BASE_URL } from 'constants/api';
import { GetAdminsResponse } from 'types/admins';
import { Admin } from "types/auth";
import { getAccessToken } from "utils/auth";

export class AdminAPI {
  private _api: AxiosInstance;
  constructor() {
    this._api = axios.create({
      baseURL: BASE_URL + "api/admins",
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    });

    this._api.defaults.headers.put["Content-Type"] = "application/json";
  }

  async getAdmins(): Promise<GetAdminsResponse> {
    try {
      const { data } = await this._api.get<GetAdminsResponse>("/", {
        headers: { authorization: getAccessToken() },
      });
      return data;
    } catch (error) {
      console.warn(error);
    }
    return null;
  }

  async createAdmin(email: string, password: string): Promise<Admin | null> {
    const { data } = await this._api.post<Admin>(
      "/",
      { email: email.toLowerCase(), password },
      {
        headers: { authorization: getAccessToken() },
      }
    );
    return data;
  }

  async deleteAdmin(adminId: Admin["id"]): Promise<boolean> {
    try {
      await this._api.delete(`/${adminId}`, {
        headers: { authorization: getAccessToken() },
      });
      return true;
    } catch (error) {
      console.warn(error);
    }
    return false;
  }

  async updateAdmin(
    adminId: Admin["id"],
    password: string
  ): Promise<Admin | null> {
    const { data } = await this._api.patch<Admin>(
      `${adminId}`,
      {
        adminId,
        password,
      },
      {
        headers: { authorization: getAccessToken() },
      }
    );
    return data;
  }
  async updateSelfPassword(
    oldPassword: string,
    password: string
  ): Promise<Admin | null> {
    const { data } = await this._api.patch<Admin>(
      '/password',
      {
        oldPassword,
        newPassword: password,
      },
      {
        headers: { authorization: getAccessToken() },
      }
    );
    return data;
  }
}

export const adminAPI = new AdminAPI();
